import { useTranslation } from 'react-i18next';

const CONTACT = 'Email: mezes3758@gmail.com · Telegram: @tez_japan_support_bot';

type Section = { heading: string; body: string };
type LangContent = { title: string; sections: Section[] };

const CONTENT: Record<'uz' | 'ru' | 'en', LangContent> = {
  uz: {
    title: 'Akkauntni oʻchirish',
    sections: [
      {
        heading: 'Qanday oʻchirish',
        body: 'Akkauntni ilova ichida Profil → Akkauntni oʻchirish orqali oʻchirishingiz mumkin yoki quyidagi aloqa orqali soʻrov yuborishingiz mumkin.',
      },
      {
        heading: 'Nimalar oʻchiriladi',
        body: 'Ism, elektron pochta, Google ulanishi, telefon raqami, bildirishnomalar, saqlangan manzillar va qoʻllab-quvvatlash chatidagi xabarlaringiz oʻchiriladi.',
      },
      {
        heading: 'Nimalar saqlanadi va nega',
        body: 'Pochta joʻnatmalari va toʻlovlar maʼlumotlari anonim tarzda (shaxsingizni aniqlab boʻlmaydigan koʻrinishda) qonuniy va buxgalteriya talablari sababli saqlanadi.',
      },
      {
        heading: 'Aloqa',
        body: CONTACT,
      },
    ],
  },
  ru: {
    title: 'Удаление аккаунта',
    sections: [
      {
        heading: 'Как удалить',
        body: 'Вы можете удалить аккаунт в приложении через Профиль → Удалить аккаунт или отправив запрос через указанный ниже контакт.',
      },
      {
        heading: 'Что удаляется',
        body: 'Имя, электронная почта, привязка Google, номер телефона, уведомления, сохранённые адреса и сообщения в чате поддержки.',
      },
      {
        heading: 'Что сохраняется и почему',
        body: 'Данные о посылках и платежах сохраняются анонимно (без возможности идентификации личности) в силу юридических и бухгалтерских требований.',
      },
      {
        heading: 'Контакты',
        body: CONTACT,
      },
    ],
  },
  en: {
    title: 'Account deletion',
    sections: [
      {
        heading: 'How to delete',
        body: 'You can delete your account in the app via Profile → Delete account, or by request through the contact below.',
      },
      {
        heading: 'What is deleted',
        body: 'Your name, email, Google link, phone number, notifications, saved addresses, and support chat messages.',
      },
      {
        heading: 'What is kept and why',
        body: 'Parcel and payment records are kept anonymously (not personally identifiable) for legal and accounting requirements.',
      },
      {
        heading: 'Contact',
        body: CONTACT,
      },
    ],
  },
};

export function PagesAccountDeletionMain() {
  const { i18n } = useTranslation();
  const lang = (['uz', 'ru', 'en'].includes(i18n.language) ? i18n.language : 'uz') as
    | 'uz'
    | 'ru'
    | 'en';
  const c = CONTENT[lang];

  return (
    <div className="mx-auto max-w-2xl px-5 py-8">
      <h1 className="text-2xl font-semibold text-ink mb-2">{c.title}</h1>

      {c.sections.map((section) => (
        <section key={section.heading}>
          <h2 className="text-lg font-semibold text-ink mt-6 mb-2">{section.heading}</h2>
          <p className="text-sm leading-relaxed text-ink-muted">{section.body}</p>
        </section>
      ))}
    </div>
  );
}
